import { render } from "./AppImageViewer.vue?vue&type=template&id=412ed2e6"
import script from "./AppImageViewer.vue?vue&type=script&lang=js"
export * from "./AppImageViewer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__